import { makeStyles } from '@material-ui/core/styles';

export const useContactInfoSectionStyles = makeStyles(
  theme => ({
    container: {
      border: `1px solid ${theme.palette.customColors.borderColor}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1, 1.5)
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      width: '100%',
      border: 'none',
      background: 'none',
      padding: 0,
      font: 'inherit',
      color: 'inherit',
      textAlign: 'left'
    },
    headerTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1)
    },
    headerLabel: {
      marginBottom: 0
    },
    expandIcon: {
      transition: 'transform 0.2s'
    },
    expandIconOpen: {
      transform: 'rotate(180deg)'
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: theme.spacing(2),
      padding: theme.spacing(1, 0),
      '&:not(:last-child)': {
        borderBottom: `1px solid ${theme.palette.divider}`
      }
    },
    rowLabel: {
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      minWidth: theme.spacing(14),
      gap: theme.spacing(1),
      color: theme.palette.text.secondary
    }
  }),
  { name: 'ContactInfoSection' }
);
